import { Component, Inject, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { detailExpand, rowsAnimation } from 'src/app/animations/template.animations';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { RoleModel } from 'src/app/models/role-model';
import { RoleMasterApiService } from 'src/app/services/domain_code/role-master-api.service';
import { BehaviorSubject, Subject, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BackendListModel } from 'src/app/models/common/list.model';
import { Router } from '@angular/router';
import { ProfileRole } from 'src/app/models/profile-role';

@Component({
    selector: 'role-table',
    templateUrl: './role-table.component.html',
    styleUrls: ['./role-table.component.scss',
        '../master-data.scss'],
    animations: [detailExpand, rowsAnimation],
})
export class RoleTableComponent implements OnInit {
    isEditable: boolean = true;
    isShown!: boolean;
    edit!: boolean;
    editing: boolean = false;
    loading: boolean = true;
    Canvas: string = "Canvas";
    columnsToDisplay = ['role_name', 'role_type', 'description', 'active', 'actions'];
    selectedRow: Element | null = null;
    @Output() canvas = new EventEmitter<string>();
    @Input()
    RefreshRoleTable = new Subject();
    displayedColumns: string[] = ['name', 'type', 'description', 'active', 'actions'];
    searchText = new BehaviorSubject<string>('');
    update: boolean = false;

    @Input()
    selectedRole: ProfileRole;
    defaultRole: ProfileRole = {
        id: null,
        is_active: true,
        name: null,
        type: null,
        description: null,
        read_only: false
    }
    save() {
        this.selectedRow = null;

    }


    openDD() {
        document.getElementById("mySidepanel")!.style.width = "493px";
        document.getElementById("mySidepanel")!.style.boxShadow = "0 0 0 99999px rgba(0, 0, 0, .5)";
        this.Canvas = " Canvas setCanvas";
        this.canvas.emit(this.Canvas);
    }
    Show() {
        this.isShown = true;
        console.log(this.isShown);
    }
    noShow() {
        this.isShown = false;
        console.log(this.isShown);
    }

    back() {
        this.router.navigateByUrl(`dashboards/role-dashboard`);

    }
    constructor(public dialog: MatDialog, private location: Location,
        private roleService: RoleMasterApiService, private router: Router,
    ) {

    }
    dd_roleList: MatTableDataSource<RoleModel>;
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    searchTerm = '';
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
    @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
    ngOnInit(): void {
        this.refreshRoleList();
        this.RefreshRoleTable.subscribe(item => {
            console.log(item)
            this.refreshRoleList();
        });

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                this.refreshRoleList(this.pageSize, this.pageIndex, searchText);
            })
        ).subscribe();
    }

    applyFilter(event) {
        this.update = true;
        this.pageIndex = 0;
        this.searchText.next(event);
    }

    ngAfterViewInit() {
        if (this.dd_roleList != null || this.dd_roleList != undefined) {
            this.dd_roleList.paginator = this.paginator;
            this.dd_roleList.sort = this.sort;
        }
    }
    // Get All Roles
    refreshRoleList(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this.roleService.getAllRoles(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                this.dd_roleList = new MatTableDataSource(response.results);
                this.pageLength = response.count;
                this.loading = false;
                this.update = false;

            }
        })
    }

    viewRoleMaster(element) {

        if (element.id != null && element.id != undefined && this.selectedRow == null) {
            console.log("patch role-master value", element);
            this.selectedRow = element;
            this.router.navigateByUrl(`/master-data/role-master?id=${element.id}`);
            setTimeout(() => {
                this.editing = true;
            }, 1000);
        }
        else {
            this.selectedRow = null;
            this.editing = false

        }
    }

    pageChanged(event: PageEvent) {
        this.update = true;
        console.log({ event });
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.refreshRoleList(this.pageSize, this.pageIndex);
    }
}
export interface Element {
    role_name: string;
    role_type: string;
    description: string;
    active: boolean;
    expandedDetail: string;
}
